import React from "react";
import { Check } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { CASE_SCENARIOS } from "../lib/caseScenarios";

const chipClass = [
  "inline-flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap",
  "rounded-md border px-3 py-1.5 text-xs font-medium",
  "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
  "disabled:pointer-events-none disabled:opacity-50",
].join(" ");

/**
 * Mode selector for the new-case run button. One teal accent, a check on the
 * selected chip, and a sideways scroll when the row does not fit.
 */
export default function CaseScenarioChips({
  selectedId = null,
  disabled = false,
  onToggle,
}) {
  const { t } = useLanguage();

  return (
    <div className="mb-3" data-testid="case-scenario-block">
      <p
        className="mb-2 text-sm text-muted-foreground"
        data-testid="scenario-caption"
      >
        {t("scenario.caption")}
      </p>
      <div
        role="group"
        aria-label={t("scenario.groupLabel")}
        data-testid="case-scenario-chips"
        className="flex flex-nowrap gap-1.5 overflow-x-auto"
      >
        {CASE_SCENARIOS.map((scenario) => {
          const Icon = scenario.icon;
          const selected = selectedId === scenario.id;
          return (
            <button
              key={scenario.id}
              type="button"
              data-testid={`scenario-chip-${scenario.id}`}
              className={
                selected
                  ? `${chipClass} border-medical bg-medical text-white`
                  : `${chipClass} border-medical/40 bg-background text-medical hover:bg-medical/5`
              }
              disabled={disabled}
              aria-pressed={selected}
              aria-label={t(scenario.nameKey)}
              onClick={() => {
                if (disabled) return;
                onToggle?.(scenario.id);
              }}
            >
              {selected ? (
                <Check
                  aria-hidden="true"
                  data-testid={`scenario-check-${scenario.id}`}
                />
              ) : null}
              <Icon aria-hidden="true" />
              <span>{t(scenario.chipKey)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
